<template>
  <div class="payout-detail-modal">
    <el-dialog :title="$t('data.loan_detail')" :visible.sync="dialogTableVisible" width="580px" class="diglog-card" @open="getDetailInfo">
      <div class="header-line" />
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('customerService.loan_amount') }}:</div>
          <div class="total-num"> {{ $store.getters.currency }}  {{ merchantInfo.loan_amount | toDivideWithDot }}</div>
        </div>
      </div>

      <div class="section-title">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('data.payout_created') }}</span>
        <span class="content-blue">{{ $t('data.payout_completed') }}</span>
      </div>

      <div class="item">
        <span class="item-left" style="color: #4B5567">{{ merchantInfo.create_time }}</span>
        <span class="content-gray">{{ merchantInfo.complete_time }}</span>
      </div>

      <div class="section-title">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.loan_transaction_no') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>
      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.transaction_id_wallet') }}</span>
        <span class="content-gray">{{ merchantInfo.repayment_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.bill_no') }}</span>
        <span class="content-gray">{{ merchantInfo.loan_order_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.loan_type') }}</span>
        <span class="content-gray">{{ loanTypeMap(merchantInfo.loan_type).label }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.collection_channel_type') }}</span>
        <span class="content-gray">{{ merchantInfo.channel_code }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchant.merchant_main_name') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_account_name }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.account') }}</span>
        <span class="content-gray">{{ merchantInfo.recipient_account_no }}</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.payee_type') }}</span>
        <span class="content-gray">-</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.payee_id_number') }}</span>
        <span class="content-gray">-</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.payee_relationship') }}</span>
        <span class="content-gray">-</span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('customerService.payee_phone_number') }}</span>
        <span class="content-gray">{{ merchantInfo.phone }}</span>
      </div>

      <el-tag :type="getLoanStatusMap(merchantInfo.transaction_status).type" min-width="150" class="payout-status tag-custom"> {{ getLoanStatusMap(merchantInfo.transaction_status).label }}</el-tag>
    </el-dialog>
  </div>
</template>

<script>
import { loanStatusMap, loanTypeMap } from '@/maps/status'
import { getCreditLoanDetail } from '@/api/settlement/settlement'
export default {
  name: 'Po_Details_Modal',
  components: {
  },
  props: {
    detailId: {
      type: String,
      default: '0'
    }
  },
  data() {
    this.TRANSACTION_STATUS = {
      fail: 4
    }
    return {
      dialogTableVisible: false, // 控制弹框显示隐藏
      listLoading: false,
      merchantInfo: {} // 用户基本信息
    }
  },
  computed: {
    getLoanStatusMap() {
      return function(value) {
        return loanStatusMap(value)
      }
    },
    loanTypeMap() {
      return function(value) {
        return loanTypeMap(value)
      }
    }
  },
  mounted() {
    this.getDetailInfo()
  },
  methods: {
    getDetailInfo() {
      const params = { transaction_id: this.detailId }
      getCreditLoanDetail(params).then(res => {
        this.merchantInfo = res.data
      })
    },
    // 改变弹框状态
    changModalStatus(value) {
      this.dialogTableVisible = value
    },

    onClickCancal() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style>
.payout-detail-modal .el-dialog__title {
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 16px;
  color: #000000;
}
.payout-detail-modal .header-line{
  margin: -26px 0 0;
  border-bottom: 1px solid #D3D7DF;
}
</style>
<style scoped lang="scss">
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.payout-detail-modal{
  .payout-status{
    text-align: center;
    position: absolute;
    top: 20px;
    left: 160px;
  }
}
</style>
